module.exports = __webpack_public_path__ + "static/media/smallLeft.84b12ce4.svg";